export default {
  html: {
    title: 'Sobre'
  }
}
